<template>
  <div class="profile">
    <div class="jumbotron">
      <img src="../assets/NearCode.png" alt="" />
      <h1 class="display-4">Olá, {{ name }}!</h1>
      <h3>
        {{ email }}
      </h3>
      <h4 v-if="type == 1">
        Administrador
      </h4>
      <h4 v-if="type == 0">Utilizador</h4>
      <!-- <a class="btn btn-primary" href="#" role="button">Atualizar password</a> -->
      <hr />
      <form v-on:submit.prevent="changePassword()">
        <h3>Atualizar Password</h3>
        <div class="form-group">
          <label for="oldPassword">Password Antiga</label>
          <input
            type="password"
            class="form-control"
            id="oldPassword"
            aria-describedby="emailHelp"
            placeholder="Insira a sua antiga Password"
            v-model="oldPassword"
          />
        </div>
        <div class="form-group">
          <label for="newPassword">Nova Password</label>
          <input
            type="password"
            class="form-control"
            id="newPassword"
            placeholder="Insira a sua nova Password"
            v-model="newPassword"
          />
        </div>
        <label for="confNewPassword">Confirmar Nova Password</label>
        <input
          type="password"
          class="form-control"
          id="confNewPassword"
          aria-describedby="emailHelp"
          placeholder="Insira a sua nova Password"
          v-model="newPassword2"
        />
        <button type="submit" class="btn btn-primary">Alterar</button>
      </form>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data: function() {
    return {
      loggedUser: "",
      name: "",
      email: "",
      type: "",
      id: "",
      oldPassword: "",
      newPassword: "",
      newPassword2: "",
    };
  },
  created() {
    this.getUser();
  },
  methods: {
    getUser() {
      this.loggedUser = this.$store.getters.getUserData;
      this.name = this.loggedUser.username;
      this.email = this.loggedUser.email;
      this.type = this.loggedUser.type;
      this.id = this.loggedUser.id_user;
    },
    async changePassword() {
      if (this.newPassword2 == this.newPassword) {
        try {
          await this.$store.dispatch("editPassword", {
            id: this.id,
            oldPassword: this.oldPassword,
            newPassword: this.newPassword,
            newPassword2: this.newPassword2,
          });
          this.$swal({
            showConfirmButton: false,
            icon: "success",
            timer: 1500,
            title: "Password Atualizada",
          });
          this.oldPassword = "";
          this.newPassword = "";
          this.newPassword2 = "";
        } catch (err) {
          this.$swal({
            showConfirmButton: true,
            icon: "warning",
            title: "Password Antiga não coincide",
          });
        }
      } else {
        this.$swal({
          showConfirmButton: true,
          icon: "warning",
          title: "Passwords Novas não coincidem!",
        });
      }
    },
  },
  computed: {
    ...mapGetters(["getUserData"]),
  },
};
</script>
<style scoped>
.profile {
  padding: 50px 50px 0px 275px;
}
img {
  height: 200px;
  width: 200px;
}
h1,
h3 {
  margin-bottom: 20px;
}
h4 {
  padding-bottom: 50px;
}
form {
  padding: 30px 300px 0px 300px;
}
button {
  margin-top: 50px;
}
</style>
